// Single place to change when the operating entity moves (e.g. Nigeria → UAE).
export const LEGAL = {
  version: "2026-10-21",
  effective: "21 October 2026",
  brand: "VISMARKS",
  entity: "VISMARKS NIGERIA LIMITED",
  entityDescription: "a company in formation in the Federal Republic of Nigeria (name reserved with the Corporate Affairs Commission, approval code 178096328517, 9 September 2026; incorporation pending), represented pending incorporation by its founder Ayanfe Mary-Grace Adesipe, with a planned affiliate in the United Arab Emirates",
  country: "Nigeria",
  governingLaw: "the laws of the Federal Republic of Nigeria",
  courts: "the courts of Lagos State, Nigeria",
  address: "Lagos, Nigeria (registered address to be published)",
  emails: { legal: "legal@vismarks.com", privacy: "privacy@vismarks.com", support: "info@vismarks.com", ip: "ip@vismarks.com", safety: "safety@vismarks.com" },
  site: "vismarks.com",
  fees: {
    sellerMonthly: "$100",
    sellerYearly: "$1,000",
    freeListings: 5,
    salesFee: "0.5%",
    hostingAddon: "$20",
    stageFee: "0.5%",
    coolingOffHours: 24,
    disputeAutoRefundDays: 7,
    payoutHoldDays: 7,
  },
  ages: { browse: 13, sell: 18 },
  ip: {
    founder: { name: "Ayanfe Mary-Grace Adesipe", role: "Founder & creator of VISMARKS", year: 2026 },
    ipHolder: "VISMARKS NIGERIA LIMITED",
    copyright: {
      owner: "Ayanfe Mary-Grace Adesipe",
      firstYear: 2026,
      authority: "Nigerian Copyright Commission (NCC)",
      certificate: "LW17172",
      work: "VISMARKS",
      category: "Literary Work",
      registered: "10 October 2026",
      law: "Copyright Act, 2022 (section 43 presumptions)",
    },
    trademarks: [
      { mark: "VISMARKS", kind: "Word mark with lightning-bolt device", status: "™", reg: null, application: "NG/TM/O/2026/476625", filed: "10 October 2026", accepted: "17 October 2026", classes: "42 — design and development of computer software; technological services", authority: "Trademarks Registry, Federal Ministry of Industry, Trade and Investment, Nigeria", owner: "Shelters on the go Limited", stage: "Accepted — awaiting advertisement in the Trademarks Journal and issue of the registration certificate" },
      { mark: "The red lightning-bolt device", kind: "Logo / device mark (part of the accepted mark above)", status: "™", reg: null, application: "NG/TM/O/2026/476625", classes: "42", authority: "Trademarks Registry, Nigeria", owner: "Shelters on the go Limited" },
      { mark: "A Million Products. Always Live.", kind: "Slogan", status: "™", reg: null, application: null, classes: null, authority: null, owner: null },
      { mark: "Transform your Store into a Global Theatre", kind: "Slogan", status: "™", reg: null, application: null, classes: null, authority: null, owner: null },
      { mark: "VISMARKS Stage", kind: "Word mark", status: "™", reg: null, application: null, classes: null, authority: null, owner: null },
    ],
    tmOwner: "Shelters on the go Limited",
  },
};

export const TM_SYMBOL = LEGAL.ip.trademarks[0].status;
export const COPYRIGHT_LINE = `© ${LEGAL.ip.copyright.firstYear === new Date().getFullYear() ? LEGAL.ip.copyright.firstYear : `${LEGAL.ip.copyright.firstYear}–${new Date().getFullYear()}`} ${LEGAL.brand}. All rights reserved.`;

export const LEGAL_DOCS = [
  { slug: "terms", path: "/terms", title: "Terms of Service", short: "Terms", blurb: "The master agreement for everyone who uses VISMARKS." },
  { slug: "seller-agreement", path: "/seller-agreement", title: "Seller Agreement", short: "Sellers", blurb: "Plans, fees, KYC, payouts and your duties as a seller." },
  { slug: "stage-terms", path: "/stage-terms", title: "Stage & Creator Terms", short: "Stage", blurb: "Tips, tickets, memberships, live shows, games, recordings and content licence." },
  { slug: "refund-policy", path: "/refund-policy", title: "Buyer Protection & Refund Policy", short: "Refunds", blurb: "When money comes back, for products and for Stage payments." },
  { slug: "community-guidelines", path: "/community-guidelines", title: "Community Guidelines & Prohibited Items", short: "Community", blurb: "What may be sold, shown and said on VISMARKS." },
  { slug: "ip-policy", path: "/ip-policy", title: "Intellectual Property & Counterfeit Policy", short: "IP", blurb: "Copyright, trademark and counterfeit reports — and how we act on them." },
  { slug: "privacy", path: "/privacy", title: "Privacy Policy", short: "Privacy", blurb: "What we collect, why, and your rights under NDPR and GDPR." },
  { slug: "cookie-policy", path: "/cookie-policy", title: "Cookie Policy", short: "Cookies", blurb: "The cookies and local storage we use, and how to control them." },
  { slug: "trademarks", path: "/trademarks", title: "Copyright, Trademarks & Brand Use", short: "Brand", blurb: "Our registered copyright, our marks and the ™/® signs, and how others may (and may not) use them." },
];
